import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { FormsModule } from '@angular/forms';
import { GeneralModule } from '../general/general.module';
import { RouterModule, Routes } from '@angular/router';
import { ContactComponent } from './components/contact/contact.component';
// import { AgmCoreModule } from '@agm/core';
import { CompanyInfoComponent } from './components/company-info/company-info.component';
import { CompanyInfoOdooService } from './services/company-info-odoo.service';
import { CompanyInfoInMemoryService } from './services/company-info-in-memory.service';
import { CompanyInfoService } from './services/company-info.service';
import { CompanyInfoStateService } from './services/company-info-state.service';
import { CompanyScheduleComponent } from './components/company-schedule/company-schedule.component';

const routes: Routes = [{
  path: 'contact',
  component: ContactComponent,
  data: {
    isInvisible: false,
  }
}];

const companyInfoServiceClass = environment.production ? CompanyInfoOdooService : CompanyInfoInMemoryService;

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    GeneralModule,
    RouterModule.forChild(routes),
    // AgmCoreModule.forRoot({
    //   apiKey: ''
    // }),
  ],
  declarations: [
    ContactComponent,
    CompanyInfoComponent,
    CompanyScheduleComponent,
  ],
  exports: [
  ],
  providers: [
    CompanyInfoStateService,
    { provide: CompanyInfoService, useClass: companyInfoServiceClass }
  ]
})
export class ContactModule { }
